import type { Span } from '@opentelemetry/api'

// The current screen span, published by ScreenSpanTracker so other parts of the app (notably the asset
// preview runtime tracing) can parent their spans under it and land in the same page-journey trace. The
// OTel context manager does not make the screen span the ambient active context across React renders, so
// it is shared explicitly here.
let activeScreenSpan: Span | undefined

export const setActiveScreenSpan = (span: Span | undefined): void => {
  activeScreenSpan = span
}

export const getActiveScreenSpan = (): Span | undefined => activeScreenSpan
